import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-logo',
    templateUrl: './logo.component.svg',
    standalone: false
})
export class LogoComponent {

  constructor() {}

  @Input() height!: string;

}
